<template>
  <v-flex xs12>

    <div v-show="error !== ''">
      <v-alert
        :value="true"
        type="error">
        {{ error }}
      </v-alert>
    </div>

    <div v-show="loading" class="text-xs-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-show="!loading & error === ''">
      <v-toolbar flat>
        <v-btn
          @click="day = day.clone().add(-7, 'days')">
          <v-icon>chevron_left</v-icon>
          前の週へ
        </v-btn>
        {{day.year()}} 年
        <v-spacer></v-spacer>
        <v-btn
          @click="day = day.clone().add(7, 'days')">
          次の週へ
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="getWeek(day)"
        class="elevation-1"
        dark
        hide-actions
      >
        <template v-slot:items="props" >
          <td>{{ `${props.item.date.format("MM/DD")}(${props.item.date.format('ddd')})`}}</td>
          <td>
            <template v-if="!props.item.null">
              <v-icon @click="flip(props.item, 'breakfast')" v-if="!props.item.breakfast.disable" :color="props.item.breakfast.selected ? 'warning' : ''">
                {{ ox(props.item.breakfast.eat ^ props.item.breakfast.selected) }}
              </v-icon>
              <v-icon disabled v-if="props.item.breakfast.disable">
                {{ ox(props.item.breakfast.eat ^ props.item.breakfast.selected) }}
              </v-icon>
            </template>
          </td>
          <td>
            <template v-if="!props.item.null">
              <v-icon @click="flip(props.item, 'dinner')" v-if="!props.item.dinner.disable"  :color="props.item.dinner.selected ? 'warning' : ''">
                {{ ox(props.item.dinner.eat ^ props.item.dinner.selected) }}
                </v-icon>
              <v-icon disabled v-if="props.item.dinner.disable">
                {{ ox(props.item.dinner.eat ^ props.item.dinner.selected) }}
              </v-icon>
            </template>
          </td>
          <td>{{ props.item.travel }}</td>
        </template>
      </v-data-table>

      <v-layout row>
        <table>
          <tr><td><v-icon>radio_button_unchecked</v-icon></td><td>食べる</td><td></td><td><v-icon>clear</v-icon></td><td>欠食する</td></tr>
        </table>

        <v-spacer></v-spacer>

        <v-btn @click="submit" color="success">反映する</v-btn>
      </v-layout>


    </div>
  </v-flex>
</template>

<script>
export default {
  async created() {
    try {
      let skips = await this.api('skipping_index', {})
      this.skipBreakfast = skips.payload.skippings.filter((q) => q.is_breakfast).map((q) => q.date)
      this.skipDinner = skips.payload.skippings.filter((q) => !q.is_breakfast).map((q) => q.date)
      this.closing_days = skips.payload.cafeteria_closing_days
      this.deadlines = skips.payload.skipping_deadlines
      this.joined_on = skips.payload.user_info.joind_on || 10101
      this.leaved_on = skips.payload.user_info.leaved_on || 99991231

      let lodgings = await this.api('lodging_index', {})
      this.travels = lodgings.payload

      this.loading = false
    }
    catch(e) {
      this.error = e.name + ': ' + e.message
    }
  },
  methods: {
    ox: (yn) => {
      return yn ? "radio_button_unchecked" : "clear"
    },
    getWeek(sd) {
      let days = []
      // Initialize
      for(let i = 0; i < 7; i++) {
        days.push({
          date: sd.clone().add(i, "days"),
          breakfast: {eat: true, disable: true, selected: false},
          dinner: {eat: true, disable: false, selected: false},
          travel: "",
          null: false,
        })
      }

      // BreakFast
      for(let sk of this.skipBreakfast) {
        let sd = this.num2date(sk)
        for(let day of days){
          if(day.date.isSame(sd, "day"))
            day.breakfast.eat = false
        }
      }

      // Dinner
      for(let sk of this.skipDinner) {
        let sd = this.num2date(sk)
        for(let day of days){
          if(day.date.isSame(sd, "day"))
            day.dinner.eat = false
        }
      }

      // Travel
      for(let tr of this.travels) {
        let begin_date = this.num2date(tr.from)
        let end_date = this.num2date(tr.until)

        for(let day of days){
          if(day.date.isBetween(begin_date, end_date, 'day', '[]')) {
            day.travel = tr.place
            day.breakfast.disable = false
          }
        }
      }

      // Null for event days
      for(let ccd of this.closing_days) {
        for(let day of days) {
          if(day.date.isSame(this.num2date(ccd), 'day')) {
            day.null = true
          }
        }
      }
      // Null for sunday
      days[6].null = true


      // Disable
      // Normal Deadline
      for(let day of days) {
        if(day.date.isBefore(this.$moment().add(-6, "hour").add(2, 'week').startOf('isoweek'), 'day')) {
          day.breakfast.disable = true
          day.dinner.disable = true
        }

        if(day.date.isBefore(this.num2date(this.joined_on)) || day.date.isAfter(this.num2date(this.leaved_on))){
          day.breakfast.disable = true
          day.dinner.disable = true
        }
      }

      // Special Deadline
      for(let dl of this.deadlines){
        let application_date = this.num2date(dl.application_date)
        let skipping_date = this.num2date(dl.skipping_date)

        if(this.$moment().add(-6, "hour").isAfter(application_date, 'day')){
          for(let day of days){
            if(day.date.isSameOrBefore(skipping_date, 'day')){
              day.dinner.disable = true,
              day.breakfast.disable = true
            }
          }
        }
      }


      // Selected
      for(let sl of this.selected){
        for(let day of days){
          if(day.date.isSame(this.num2date(sl.date), 'day')){
            day[sl.kind].selected = true
          }
        }
      }


      return days
    },
    update(surs) {
      for(let sur of surs){
        if(sur.result === "success"){
          if(sur.request.type === "add"){
            if(sur.request.skipping.is_breakfast){
              let index = this.skipBreakfast.indexOf(sur.request.skipping.date)
              if(index !== -1)
                continue
              this.skipBreakfast.push(sur.request.skipping.date)
            }else{
              let index = this.skipDinner.indexOf(sur.request.skipping.date)
              if(index !== -1)
                continue
              this.skipDinner.push(sur.request.skipping.date)
            }
          }else if(sur.request.type === "remove"){
            if(sur.request.skipping.is_breakfast){
              let index = this.skipBreakfast.indexOf(sur.request.skipping.date)
              if(index == -1)
                continue
              this.skipBreakfast.splice(index, 1)
            }else{
              let index = this.skipDinner.indexOf(sur.request.skipping.date)
              if(index == -1)
                continue
              this.skipDinner.splice(index, 1)
            }
          }
          continue
        }
        if(sur.result === "failure"){
          this.error = sur.reason
        }
      }
      this.selected = []
      this.loading = false
    },
    async flip(day, kind) {
      let numDay = this.date2num(day.date)
      let elem = this.selected.findIndex((elem) => elem.date == numDay && elem.kind == kind)
      if(elem >= 0){
        this.selected.splice(elem, 1)
      }else{
        this.selected.push({date: numDay, kind: kind, to: !day[kind].eat})
      }
    },
    async submit(){
      this.loading = true
      let query = this.selected.map(e => {return {type: e.to ? "remove" : "add", skipping:{"date":e.date, "is_breakfast":Number(e.kind === 'breakfast')}}})
      try{
        let update_result = await this.api('skipping_update', {"requests": query})
        this.update(update_result.payload.results)
      }
      catch (e) {
        this.error = e.name + ": " + e.message
      }
      return true
    }
  },
  data () {
    return {
      loading: true,
      error: "",
      headers: [
        {
          text: '日付',
          align: 'left',
          sortable: false,
          value: 'date',
          width: "15%"
        },
        { text: '朝食', value: 'breakfast', sortable:false, width:"10%"},
        { text: '夕食', value: 'dinenr', sortable:false, width:"10%"},
        { text: '外泊先', value: 'travel', sortable:false, width:"55%"},
      ],
      day: this.$moment().startOf('week').add(1, "days"),
      skipBreakfast: [],
      skipDinner: [],
      travels: [],
      closing_days: [],
      user: localStorage.user || "",
      deadlines: [],
      joined_on: 0,
      leaved_on: 0,
      selected: []
    }
  },
}
</script>
